var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlide1Home(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.197,
    height: 78.197,
    viewBox: "0 0 78.197 78.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M26.063,52.133a18.433,18.433,0,1,1,13.035,5.4,18.434,18.434,0,0,1-13.035-5.4M39.1,0A39.1,39.1,0,1,0,66.745,11.451,38.977,38.977,0,0,0,39.1,0Z",
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M21.946,76.125,9.635,100.51A39.1,39.1,0,0,0,84.5,82.254C75.082,100,54.647,110.521,37.4,101.474a18.326,18.326,0,0,1-2.213-1.281c-3.37-2.14-4.99-3.987-5.369-5.579A18.454,18.454,0,0,1,36.07,69.06a6.831,6.831,0,0,0-1-.072c-5.948,0-13.122,7.137-13.122,7.137",
    transform: "translate(-9.635 -68.988)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M11.451,25.619a39.1,39.1,0,0,0,39,65.067c-31.16-.237-42.985-31.855-24.384-50.455A18.437,18.437,0,0,1,45.818,36.1l2.061-3.268L41.39,27.879,16.527,21.336a39.385,39.385,0,0,0-5.075,4.283",
    transform: "translate(0 -21.336)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M11.455,11.451A39.1,39.1,0,0,0,1.971,51.365C-2.3,34.126,18.492,15.882,42.486,20.977a20.592,20.592,0,0,1,4.065,1.255,10.334,10.334,0,0,0,11.5-2.089l.1-.1a10.269,10.269,0,0,0-3.07-16.635,39.14,39.14,0,0,0-43.634,8.045",
    transform: "translate(-0.005)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dp-companies-logo",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 92.507,
    height: 92.507,
    transform: "translate(-14.982 80.465) rotate(-82.1)",
    fill: "#f6f5fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(3.237 23.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 75.603,
    height: 58.835,
    transform: "translate(0 -0.001)",
    fill: "#a2a2a2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 7.169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 115.712,
    height: 91.753,
    transform: "translate(-30.495 87.255) rotate(-81.63)",
    fill: "#727272"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 113.58,
    height: 114.474,
    transform: "matrix(0.675, -0.737, 0.737, 0.675, -50.198, 28.909)",
    fill: "#61cafa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide1Home);
export default __webpack_public_path__ + "static/media/slide1_home.f7135785dd4c0990c26ab93284ad1f61.svg";
export { ForwardRef as ReactComponent };